/**
 * Service for formatting Facebook Click ID values into _fbc cookie format
 * Based on Facebook's official cookie format: fb.{subdomainIndex}.{timestamp}.{fbclid-value}
 *
 * https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
 */
export class FacebookCookieService {
    public static formatFbcValue(fbclid: string): string {
        const currentTime = new Date().getTime();
        const subdomainIndex = this.calculateSubdomainIndex();
        
        return [
            'fb',
            subdomainIndex,
            currentTime,
            fbclid
        ].join('.');
    }

    private static calculateSubdomainIndex(): number {
        const hostnameParts = window.location.hostname.split('.');
        
        // For Facebook's _fbc cookie, the subdomain index represents domain depth
        // 'com' = 0, 'example.com' = 1, 'www.example.com' = 2
        return Math.max(0, hostnameParts.length - 1);
    }

    public static shouldOverrideFbc(oldValue: string | undefined, newProcessedValue: string, rawValue: string): boolean {
        if (!oldValue) {
            return true;
        }

        // Ensure old value is in the correct format and has a correct Fbclid
        const parts = oldValue.split('.');
        if (parts.length !== 4 || parts[0] !== 'fb') {
            return true;
        }
        
        const existingFbclid = parts[3];
        return existingFbclid !== rawValue;
    }
}
